import { closeToast, showConfirmDialog, showLoadingToast, showToast } from 'vant'

export const ui = {
  toast: {
    show(options) {
      return showToast(typeof options === 'string' ? options : { message: options?.text || '', duration: 1000 })
    },
    text(message) {
      return showToast({ message, duration: 1000 })
    }
  },
  loading: {
    show(options = {}) {
      return showLoadingToast({ message: options.text || '', duration: 0, forbidClick: true })
    },
    hide() {
      closeToast()
    }
  },
  confirm: {
    prompt(message, options = {}) {
      const value = window.prompt(message || options.title || '', options.default || '')
      if (value === null) options.onCancel?.()
      else options.onConfirm?.(value)
    },
    setInputValue() {},
    show(options = {}) {
      return showConfirmDialog({ title: options.title, message: options.content || options.message })
        .then(() => options.onConfirm?.())
        .catch(() => options.onCancel?.())
    }
  }
}

export const UiServicesPlugin = {
  install(app) {
    app.config.globalProperties.$vux = ui
  }
}
